import * as React from "react"

import { FlowDictionaryTerm } from "types"
import * as styles from "./styles.module.scss"

export interface DictionaryTermProps {
  term: FlowDictionaryTerm
}

const Term: React.FC<DictionaryTermProps> = ({ term }) => {
  const { title, description } = term
  return (
    <li className={styles.item}>
      <i className={styles.lineEyebrow}></i>
      <h4 className={styles.itemHeading}>{title}</h4>
      <p className={styles.description}>{description}</p>
    </li>
  )
}

export default Term
